<template>
	<div class="no-data">
		<img src="@/assets/images/no.png"/>
		<div>{{msg}}</div>
	</div>
</template>

<script>
	export default {
		name:"noData",
		props:{
			msg:{
				type: String,
				required: false,
				default: ""
			}
		}
	}
</script>

<style scoped lang="scss">
	.no-data{
		width: 100%;
		padding: calc(50vh - 300px) 0px;
		background: #FFFFFF;
		text-align: center;
		img{
			width: 120px;
			height: 120px;
		}
		div{
			font-size: 16px;
			font-weight: 500;
			color: #9E9E9E;
			margin-top: 12px;
		}
	}
</style> 